// The system fib (DWLF-334) from GET /v2/fib-levels/system: the current
// cycle-fib leg per timeframe, as stored by the nightly job, and the chart
// guides drawn from it. Separate from marketsSlice so it can be tested without
// the slice's browser-only imports.

const TIMEFRAME_TAG = { weekly: 'W', daily: 'D' };
const TIMEFRAME_COLOR = { weekly: 'rgba(255, 200, 0, 0.75)', daily: 'rgba(255, 255, 0, 0.45)' };

const finite = (value) => typeof value === 'number' && Number.isFinite(value);

/** The stored row as the chart's fib set, or null when the row is not a cycle-fib row. */
export const toChartFib = (row) => {
  if (!row || row.engine !== 'cycleFib' || !Array.isArray(row.legs)) {return null;}
  const legs = row.legs
    .filter((leg) => leg && Array.isArray(leg.levels))
    .map((leg) => ({ ...leg, levels: leg.levels.filter((level) => level && typeof level === 'object') }))
    .filter((leg) => leg.levels.length > 0);
  return legs.length ? { asOf: row.date, legs } : null;
};

// One guide per line a trader reads off a fib: the retracements, the golden
// pocket's far edge (its near edge is the 61.8%), the extensions and the origin.
// A bullish leg retraces down, so its 65% is the pocket's lower edge; a bearish one's the upper.
const levelLines = (level, direction) => {
  if (level.kind === 'goldenPocket') {
    if (!finite(level.lower) || !finite(level.upper)) {return [];}
    return [{ label: '65%', price: direction === 'bearish' ? level.upper : level.lower }];
  }
  if (!finite(level.price)) {return [];}
  return [{ label: level.kind === 'origin' ? 'origin' : level.label, price: level.price }];
};

/**
 * Price-pane guides for the fib set: `W 61.8%`, `D origin`, … drawn from the
 * leg's start. A developing leg's labels end in `~`: its levels move as the
 * leg extends.
 */
export const fibGuides = (fib) => (fib?.legs || []).flatMap((leg) => {
  const tag = `${TIMEFRAME_TAG[leg.timeframe] || leg.timeframe}${leg.status === 'developing' ? '~' : ''}`;
  const startTime = Date.parse(leg.start?.date);
  return leg.levels.flatMap((level) => levelLines(level, leg.direction)).map(({ label, price }) => ({
    y: price,
    dashed: true,
    color: TIMEFRAME_COLOR[leg.timeframe] || TIMEFRAME_COLOR.daily,
    label: `${tag} ${label}`,
    ...(Number.isFinite(startTime) ? { startTime } : {}),
  }));
});
